<template>
  <div class="order-handle-flow">
    <img
      class="top-img"
      src="../assets/imgs/order-handle-flow/背景-流程@2x.png"
    />
    <div class="main-box">
      <div class="item-box">
        <div class="title-box">
          <div class="num">01</div>
          <h2>上传资料</h2>
          <div class="red-circle-box">
            <div class="red-circle"><div class="red"></div></div>
          </div>
        </div>
        <div class="content-box">
          <ul>
            <li>· 手机拍摄一键智能生成签证照片</li>
            <li>· 在线上传签证所需的电子资料</li>
            <li
              v-if="
                need_interview ||
                need_delivery ||
                (!need_interview && !need_delivery && visa_application_id)
              "
            >
              · 在线填写签证电子申请表
            </li>
            <li v-if="need_interview || need_delivery">
              · 在线选择方便前往使馆面签的日期
            </li>
          </ul>
          <img src="../assets/imgs/order-handle-flow/img-流程-上传@2x.png" />
        </div>
      </div>
      <div class="item-box">
        <div class="title-box">
          <div class="num">02</div>
          <h2>提交订单</h2>
          <div class="red-circle-box">
            <div class="red-circle"><div class="red"></div></div>
          </div>
        </div>
        <div class="content-box">
          <ul>
            <li>· 确认签证信息并完成支付，支持微信/支付宝</li>
            <li v-if="need_interview || need_delivery">
              · 因使馆面签的名额有限，使馆面签日期如需修改，可能产生额外费用
            </li>
            <li
              v-if="
                !need_interview && !need_delivery && need_pickup_material === 1
              "
            >
              · 将签证需要的纸质资料原件寄送给我们
            </li>
            <li
              v-if="
                !need_interview && !need_delivery && need_pickup_material === 2
              "
            >
              · 电子签全程电子化办理，无需另外邮寄资料
            </li>
          </ul>
          <img
            src="../assets/imgs/order-handle-flow/img-流程-提交订单@2x.png"
          />
        </div>
      </div>
      <div class="item-box">
        <div class="title-box">
          <div class="num">03</div>
          <h2>
            {{ need_interview || need_delivery ? '审核预约' : '审核办理' }}
          </h2>
          <div class="red-circle-box">
            <div class="red-circle"><div class="red"></div></div>
          </div>
        </div>
        <div class="content-box">
          <ul>
            <li>· 签证专家将完整预审核您的签证资料</li>
            <li>· 预审未通过的电子签证资料支持在线补充或更新</li>
            <li v-if="need_interview || need_delivery">
              · 签证专家将为您预约赴馆面签的具体时间
            </li>
            <li v-if="need_interview || need_delivery">
              ·
              签证专家将发送详细的赴馆通知书，请您根据赴馆通知书中的信息进行赴馆前的准备
            </li>
            <li v-if="!need_interview && !need_delivery">
              · 预审通过的签证申请，将第一时间递交使馆进行办理
            </li>
          </ul>
          <img
            src="../assets/imgs/order-handle-flow/img-流程-审核办理@2x.png"
          />
        </div>
      </div>
      <div class="item-box" v-if="need_interview || need_delivery">
        <div class="title-box">
          <div class="num">04</div>
          <h2>使馆面签</h2>
          <div class="red-circle-box">
            <div class="red-circle"><div class="red"></div></div>
          </div>
        </div>
        <div class="content-box">
          <ul>
            <li v-if="!need_delivery">
              · 申请人前往使馆面签前，将接受面试培训
            </li>
            <li>· 申请人需要提前准备好相应的赴馆资料</li>
            <li>· 申请人按照指定赴馆日期前往使馆进行面签</li>
          </ul>
          <img
            src="../assets/imgs/order-handle-flow/img-流程-出签配送@2x.png"
          />
        </div>
      </div>
      <div class="item-box" v-if="!need_interview && !need_delivery">
        <div class="title-box">
          <div class="num">04</div>
          <h2>出签配送</h2>
          <div class="red-circle-box">
            <div class="red-circle"><div class="red"></div></div>
          </div>
        </div>
        <div class="content-box">
          <ul>
            <li v-if="need_pickup_material === 1">
              · 使馆出签后，您的签证资料将通过顺丰安全回寄
            </li>
            <li v-if="need_pickup_material === 2">
              · 电子签证出签后，可通过APP在线下载并打印使用
            </li>
            <!-- <li>· 若不幸发生拒签，熊猫签证将按照拒签退款规则进行退款，详细信息请查看<span class="red" @click="goToRefundExplain">《拒签退款说明》</span>。</li> -->
          </ul>
          <img
            src="../assets/imgs/order-handle-flow/img-流程-出签配送@2x(2).png"
          />
        </div>
      </div>
      <div class="item-box" v-if="need_interview || need_delivery">
        <div class="title-box">
          <div class="num">05</div>
          <h2>出签配送</h2>
          <div class="red-circle-box">
            <div class="red-circle"><div class="red"></div></div>
          </div>
        </div>
        <div class="content-box">
          <ul>
            <li>· 申请人可选择由使馆方邮寄出签结果</li>
            <li>· 为保障您的权益，客服可能会联系您了解实际出签情况</li>
            <!-- <li>· 若不幸发生拒签，熊猫签证将按照拒签退款规则进行退款，详细信息请查看<span class="red" @click="goToRefundExplain">《拒签退款说明》</span>。</li> -->
          </ul>
          <img
            src="../assets/imgs/order-handle-flow/img-流程-出签配送@2x(2).png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';
import ProductService from '../services/productService';

export default {
  data() {
    return {
      productService: new ProductService(this.$http),
      need_interview: '',
      need_delivery: '',
      need_pickup_material: '',
      visa_application_id: '',
    };
  },
  mounted() {
    this.getData(this.productService.getProductId());
  },
  created() {
    utils.setTitle('办理流程');
  },
  methods: {
    getData(projectId) {
      if (!projectId) return;
      this.productService.getProduct(projectId).then((response) => {
        const product = response.body.body;
        this.need_interview = product.need_interview;
        this.need_delivery = product.need_delivery;
        this.need_pickup_material = product.need_pickup_material;
        this.visa_application_id = product.visa_application_id;
      });
    },

    goToRefundExplain() {
      this.$router.push({ path: '/refundExplain' });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../styles/theme.less';

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  line-height: 1;
}
.red {
  color: @red;
}

.order-handle-flow {
  background-color: #ffffff;
  .top-img {
    width: 100%;
  }
  .main-box {
    padding: 0.46rem 0 0 0.16rem;
    .item-box {
      border-left: 1px dashed #ff8385;
      padding: 0 0 0.66rem 0.1rem;
      .title-box {
        position: relative;
        padding-left: 0.14rem;
        margin-bottom: 0.16rem;
        .num {
          background: linear-gradient(
            to top,
            rgba(250, 250, 250, 1),
            rgba(226, 226, 232, 1)
          );
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          font-size: 0.4rem;
          font-weight: bold;
          position: absolute;
          top: -0.3rem;
          left: 0.14rem;
          z-index: 1;
        }
        h2 {
          color: #333333;
          font-size: 0.24rem;
          font-weight: 500;
          position: relative;
          z-index: 2;
        }
        .red-circle-box {
          width: 0.24rem;
          height: 0.24rem;
          background-color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 0rem;
          left: -0.22rem;
          .red-circle {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 0.12rem;
            height: 0.12rem;
            border: 0.01rem solid #ff8385;
            border-radius: 50%;
            background-color: #ffffff;
            .red {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 0.06rem;
              height: 0.06rem;
              border-radius: 50%;
              background-color: #ff8385;
            }
          }
        }
      }
      .content-box {
        background-color: #fafafa;
        color: #686363;
        padding: 0.16rem 0.12rem 0.44rem 0.12rem;
        border-radius: 0.32rem 0 0 0;
        position: relative;
        ul {
          list-style: none;
          position: relative;
          z-index: 2;
          li {
            color: #686363;
            font-size: 0.14rem;
            line-height: 0.21rem;
          }
        }
        img {
          position: absolute;
          right: 0.16rem;
          bottom: 0;
          width: 0.84rem;
          height: 0.72rem;
        }
      }
      &:last-child {
        border-left: none;
        padding-bottom: 0.35rem;
      }
    }
  }
}
</style>
